<template>
  <div id="LangindAgencies" class="row">
    <div class="left col-md-6" style="background: #ddd" v-if="loading_map">
      <button
        class="btn btn-primary goBack"
        @click="
          hide();
          $emit('backHome');
        "
      >
        <font-awesome-icon class="icon" icon="chevron-left" />
        <span>{{ $t("Home") }}</span>
      </button>
      <div class="section-loader">
        <img src="/world-loader-white.gif" alt="" style="width: 100px" />
      </div>
    </div>
    <div class="left col-md-6" v-else>
      <button
        class="btn btn-primary goBack"
        @click="
          hide();
          $emit('backHome');
        "
      >
        <font-awesome-icon class="icon" icon="chevron-left" />
        <span>{{ $t("Home") }}</span>
      </button>
      <GmapMap
        :center="center"
        :zoom="13"
        ref="Gmap"
        map-type-id="terrain"
        class="map"
        :disableDefaultUI="true"
        :options="{
          zoomControl: true,
          mapTypeControl: false,
          scaleControl: false,
          streetViewControl: false,
          rotateControl: false,
          fullscreenControl: true,
          disableDefaultUi: false,
          styles: styles,
        }"
      >
        <GmapMarker
          v-if="position_is_correct"
          :position="position"
          @click="opened_info_window = 0"
          :clickable="true"
          :icon="{
            url: Config.map.pin_me,
            scaledSize: { width: 25, height: 25 },
            labelOrigin: { x: 0, y: 0 },
          }"
        >
          <GmapInfoWindow
            style="color: #333 !important"
            :opened="opened_info_window == 0"
          >
            <div class="title">{{ $t("MyPosition") }}</div>
          </GmapInfoWindow>
        </GmapMarker>
        <GmapCluster :zoomOnClick="true">
          <GmapMarker
            :key="'Marker' + index"
            v-for="(m, index) in markers"
            :position="m.position"
            @click="opened_info_window = m.vendor.id"
            :clickable="true"
            :icon="{
              url: Config.map.marker,
              scaledSize: { width: 40, height: 50 },
              labelOrigin: { x: 20, y: 25 },
            }"
          >
            <GmapInfoWindow
              style="overflow-x: hidden !important"
              :opened="opened_info_window == m.vendor.id"
              @click="openVendor(m.vendor.shortcode)"
            >
              <div class="m-0 p-0" @click="openVendor(m.vendor.shortcode)">
                <MapWindowAgency
                  :Recommended="false"
                  :Vendor="m.vendor"
                  :direction="$i18n.locale === 'ar' ? 'rtl' : 'ltr'"
                  @click="openVendor(m.vendor.shortcode)"
                />
              </div>
            </GmapInfoWindow>
          </GmapMarker>
        </GmapCluster>
      </GmapMap>
    </div>

    <div class="right col-md-6">
      <div style="margin-top: 5px; width: auto;">
        <div class="form-button">
          <input
            type="search"
            v-model="filter.search_keyword"
            placeholder="Search..."
          />
          <button type="submit" @click="searchAfterPause">Search</button>
        </div>
      </div>

      <div v-show="loading">
        <div class="section-loader">
          <img src="/loader-circle.gif" alt="" />
          <span>{{ $t("Loading") }}</span>
        </div>
      </div>
      <div v-show="!loading">
        <div class="w-100"></div>
        <div class="recommendation" v-if="recommended_vendor">
          <div class="subtitle">- {{ $t("Recommended") }}</div>

          <div class="row">
            <div
              class="col-md-6 p-2"
              @click="
                openVendor(recommended_vendor.shortcode);
                pinMapTo(recommended_vendor.id, {
                  lat: recommended_vendor.lat,
                  lng: recommended_vendor.lng,
                });
              "
            >
              <Agency :Recommended="true" :Vendor="recommended_vendor" />
            </div>
          </div>
        </div>

        <div class="vendors" v-if="vendors && vendors.length">
          <div class="subtitle">- {{ $t("YouCanAlsoFind") }}</div>

          <div class="row">
            <div
              class="col-md-6 p-2"
              v-for="item in vendors"
              :key="item.id"
              @click="
                openVendor(item.shortcode);
                pinMapTo(item.id, { lat: item.lat, lng: item.lng });
              "
            >
              <Agency :Recommended="false" :Vendor="item" />
            </div>
          </div>
          
        </div>
        <vs-pagination
            @change="initPagePagination"
            :color="pColor"
            style="margin: 15px auto 15px auto; z-index: 0; position: relative;"
            :total="last_page"
            v-model="currentPage"
          ></vs-pagination>
        <br />
        <br />
        <br />
        <br />
        <br />
      </div>
    </div>
  </div>
</template>

<script>
import $ from "jquery";
import Agency from "./components/Agency.vue";
import MapWindowAgency from "./components/MapWindowAgency.vue";
import { vendorsService, controller } from "/src/_services";

import GmapCluster from "vue2-google-maps/dist/components/cluster";

let bodyStyles = document.body.style;
let timer = setTimeout(() => {}, 1);

export default {
  data: () => ({
    pColor: bodyStyles.getPropertyValue("--primary"),
    perPage: 6,
    last_page: 1,
    currentPage: 0,
    loading: false,
    loading_map: true,
    position: {
      lat: 36,
      lng: 10,
    },
    center: {
      lat: 36,
      lng: 10,
      // lat: 14.7167586,
      // lng: -17.4780091,
    },

    position_is_correct: false,
    filter: {
      search_keyword: null,
      page: 1,
    },

    vendors: null,
    recommended_vendor: null,
    markers: [],
    opened_info_window: 0,

    styles: [
      {
        featureType: "administrative",
        elementType: "geometry",
        stylers: [
          {
            visibility: "off",
          },
        ],
      },
      {
        featureType: "administrative.land_parcel",
        elementType: "labels",
        stylers: [
          {
            visibility: "off",
          },
        ],
      },
      {
        featureType: "poi",
        stylers: [
          {
            visibility: "off",
          },
        ],
      },
      {
        featureType: "road",
        elementType: "labels.icon",
        stylers: [
          {
            visibility: "off",
          },
        ],
      },
      {
        featureType: "road.local",
        elementType: "labels",
        stylers: [
          {
            visibility: "off",
          },
        ],
      },
      {
        featureType: "transit",
        stylers: [
          {
            visibility: "off",
          },
        ],
      },
    ],
  }),
  components: {
    Agency,
    MapWindowAgency,
    GmapCluster,
  },
  mounted() {
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(
        function(position) {
          this.position.lat = position.coords.latitude;
          this.position.lng = position.coords.longitude;
          this.position_is_correct = true;

          this.center.lat = position.coords.latitude;
          this.center.lng = position.coords.longitude;
          // this.centerSenegal.lat = position.coords.latitude;
          // this.centerSenegal.lng = position.coords.longitude;
          this.currentPage = 1;
          // this.initPage();
          //  setInterval(() => {
          //  this.initPage();
          // }, "30000");
        }.bind(this),
        function() {
          //console.log("not working");
          this.position.lng = 10.1799885;
          this.position.lat = 36.7974303;
          this.position_is_correct = false;
          this.center.lng = 10.1799885;
          this.center.lat = 36.7974303;
          // this.center.lng = -17.4780091;
          // this.center.lat = 14.7167586;

          this.currentPage = 1;
          // this.initPage();
          //  setInterval(() => {
          //  this.initPage();
          // }, "30000");
        }.bind(this),
        { timeout: 5000 }
      );
    } else {
      alert("Geolocation is not supported by this browser.");
    }
  },
  methods: {
    searchAfterPause() {
      clearTimeout(timer);
      timer = setTimeout(() => {
        controller.abort();
        this.filterAgencies();
      }, 700);
    },
    pinMapTo(id, position) {
      this.opened_info_window = id;
      // this.center = position
      this.$refs.Gmap.panTo(position);
    },
    openVendor(short_code) {
      this.$emit("openVendor", short_code);
      this.$emit("toggleButtonOn");
      this.$event.$emit("updateLoading", true);
    },
    initPage() {
      this.loading = true;
      vendorsService
        .filter(
          {
            organization: this.Config.organization_id,
            lat: this.position.lat,
            lng: this.position.lng,
            //       lat: "14.7167586",
            // lng: "-17.4780091",
            keyword: this.filter.search_keyword,
            radius: this.Config.options.agencies_filter_radius,
            append: "rating",
            page: this.currentPage,
            perPage: this.perPage,
          }
        )
        .then(
          function(data) {
            this.vendors = data.data.data.map((obj) => {
              if (
                !obj.shortest_waiting_time ||
                obj.shortest_waiting_time == 0
              ) {
                obj.iconImgNumber = 0;
              } else if (
                obj.shortest_waiting_time <=
                this.Config.queue_status_icons.show_1_person_until
              ) {
                obj.iconImgNumber = 1;
              } else if (
                obj.shortest_waiting_time <=
                this.Config.queue_status_icons.show_2_persons_until
              ) {
                obj.iconImgNumber = 2;
              } else if (
                obj.shortest_waiting_time <=
                this.Config.queue_status_icons.show_3_persons_until
              ) {
                obj.iconImgNumber = 3;
              } else if (
                obj.shortest_waiting_time <=
                this.Config.queue_status_icons.show_4_persons_until
              ) {
                obj.iconImgNumber = 4;
              } else {
                obj.iconImgNumber = 5;
              }

              let time_to_wait_in_hours = Math.floor(
                obj.shortest_waiting_time / 60
              );
              let time_to_wait_in_minutes = obj.shortest_waiting_time % 60;
              obj.time_to_wait =
                (time_to_wait_in_hours > 0
                  ? time_to_wait_in_hours + "h "
                  : "") +
                time_to_wait_in_minutes +
                " " +
                this.$t("Min");

              return obj;
            });
            this.recommended_vendor = this.vendors[0];

            let i = 1;
            this.markers = [];
            this.vendors.map((vendor) => {
              this.markers.push({
                id: i,
                position: {
                  lat: Number(vendor.lat),
                  lng: Number(vendor.lng),
                },
                vendor,
              });
              i++;
              return vendor;
            });
            this.last_page = data.data.last_page;
          }.bind(this)
        )
        .finally(() => {
          this.loading = false;
          this.loading_map = false;
        });
    },
    initPagePagination(page) {
      this.loading = true;
      vendorsService
        .filter(
          {
            organization: this.Config.organization_id,
            lat: this.position.lat,
            lng: this.position.lng,
            // lat: "14.7167586",
            // lng: "-17.4780091",
            keyword: this.filter.search_keyword,
            radius: this.Config.options.agencies_filter_radius,
            append: "rating",
            page: page,
            perPage: this.perPage,
          }
        )
        .then(
          function(data) {
            this.vendors = data.data.data.map((obj) => {
              if (
                !obj.shortest_waiting_time ||
                obj.shortest_waiting_time == 0
              ) {
                obj.iconImgNumber = 0;
              } else if (
                obj.shortest_waiting_time <=
                this.Config.queue_status_icons.show_1_person_until
              ) {
                obj.iconImgNumber = 1;
              } else if (
                obj.shortest_waiting_time <=
                this.Config.queue_status_icons.show_2_persons_until
              ) {
                obj.iconImgNumber = 2;
              } else if (
                obj.shortest_waiting_time <=
                this.Config.queue_status_icons.show_3_persons_until
              ) {
                obj.iconImgNumber = 3;
              } else if (
                obj.shortest_waiting_time <=
                this.Config.queue_status_icons.show_4_persons_until
              ) {
                obj.iconImgNumber = 4;
              } else {
                obj.iconImgNumber = 5;
              }

              let time_to_wait_in_hours = Math.floor(
                obj.shortest_waiting_time / 60
              );
              let time_to_wait_in_minutes = obj.shortest_waiting_time % 60;
              obj.time_to_wait =
                (time_to_wait_in_hours > 0
                  ? time_to_wait_in_hours + "h "
                  : "") +
                time_to_wait_in_minutes +
                " " +
                this.$t("Min");

              return obj;
            });
            this.recommended_vendor = this.vendors[0];

            let i = 1;
            this.markers = [];
            this.vendors.map((vendor) => {
              this.markers.push({
                id: i,
                position: {
                  lat: Number(vendor.lat),
                  lng: Number(vendor.lng),
                },
                vendor,
              });
              i++;
              return vendor;
            });
            this.last_page = data.data.last_page;
          }.bind(this)
        )
        .finally(() => {
          this.loading = false;
          this.loading_map = false;
        });
    },
    show() {
      $("#LangindAgencies").css("margin-left", "0");
      // $('#LangindAgencies').css('display', 'block')
    },
    hide() {
      $("#LangindAgencies").css("margin-left", "100%");
      this.$emit("removeBorder");
    },
    filterAgencies() {
      this.loading = true;
      vendorsService
        .filter(
          {
            organization: this.Config.organization_id,
            lat: this.position.lat,
            lng: this.position.lng,

            //       lat: "14.7167586",
            // lng: "-17.4780091",

            keyword: this.filter.search_keyword,
            radius: this.Config.options.agencies_filter_radius,
            append: "rating",
            page: this.currentPage,
            perPage: this.perPage,
          }
        )
        .then(
          function(data) {
            this.vendors = data.data.data.map((obj) => {
              if (
                !obj.shortest_waiting_time ||
                obj.shortest_waiting_time == 0
              ) {
                obj.iconImgNumber = 0;
              } else if (
                obj.shortest_waiting_time <=
                this.Config.queue_status_icons.show_1_person_until
              ) {
                obj.iconImgNumber = 1;
              } else if (
                obj.shortest_waiting_time <=
                this.Config.queue_status_icons.show_2_persons_until
              ) {
                obj.iconImgNumber = 2;
              } else if (
                obj.shortest_waiting_time <=
                this.Config.queue_status_icons.show_3_persons_until
              ) {
                obj.iconImgNumber = 3;
              } else if (
                obj.shortest_waiting_time <=
                this.Config.queue_status_icons.show_4_persons_until
              ) {
                obj.iconImgNumber = 4;
              } else {
                obj.iconImgNumber = 5;
              }

              let time_to_wait_in_hours = Math.floor(
                obj.shortest_waiting_time / 60
              );
              let time_to_wait_in_minutes = obj.shortest_waiting_time % 60;
              obj.time_to_wait =
                (time_to_wait_in_hours > 0
                  ? time_to_wait_in_hours + "h "
                  : "") +
                time_to_wait_in_minutes +
                " " +
                this.$t("Min");

              return obj;
            });
            this.recommended_vendor = this.vendors[0];

            let i = 1;
            this.markers = [];
            this.vendors.map((vendor) => {
              this.markers.push({
                id: i,
                position: {
                  lat: Number(vendor.lat),
                  lng: Number(vendor.lng),
                },
                vendor,
              });
              i++;
              return vendor;
            });
            this.last_page = data.data.last_page;
          }.bind(this)
        )
        .catch((err) => {
          console.log(err);
        })
        .finally(() => {
          this.loading = false;
          this.loading_map = false;
        });
    },
  },
};
</script>

<style lang="scss" scoped>
#LangindAgencies {
  width: 100vw;

  overflow: hidden !important;
  position: absolute;
  top: 0;
  transition: 0.5s;
  background: #fff;

  margin-left: 100%;
  .test {
    display: flex;
  }
  .section-loader {
    position: absolute;
    top: 40%;
    left: 50%;
    transform: translate(-50%, -50%);
    text-align: center;
    img {
      width: 50px;
    }
    span {
      display: block;
      font-size: 15px;
      margin-top: 15px;
    }
  }
  .left {
    z-index: 98;
    button {
      position: absolute;
      top: 10px;
      left: 10px;
      background: var(--primary);
      color: var(--primary-font);
      border-radius: 3px;
      z-index: 99;
      padding: 5px 15px;
      height: 35px;
      .icon {
        margin-right: 5px;
        font-size: 10px;
      }
    }
    button:hover {
      background: var(--primary-hover);
    }
    .map {
      width: 100%;
      height: 100vh;
      min-height: -webkit-fill-available;
      z-index: 98;
    }
  }
  .right {
    padding: 10px 20px 40px 20px;
    overflow-y: scroll !important;
    height: 100vh;
    min-height: -webkit-fill-available;
    .subtitle {
      margin-top: 20px;
      font-size: 17px;
      color: #555;
      /*letter-spacing: 2px;*/
    }
  }

  .form-button {
    color: #555;
    display: flex;
    padding: 2px;
    border: 1px solid currentColor;
    border-radius: 5px;
  }

  input[type="search"] {
    border: none;
    width:  100%;
    background: transparent;
    margin: 0;
    padding: 7px 8px;
    font-size: 14px;
    color: inherit;
    border: 1px solid transparent;
    border-radius: inherit;
  }

  input[type="search"]::placeholder {
    color: #bbb;
  }

  button[type="submit"] {
    text-indent: -999px;
    overflow: hidden;
    width: 40px;
    padding: 0;
    margin: 0;
    border: 1px solid transparent;
    border-radius: inherit;
    background: var(--primary) url("/search.png") no-repeat center;
    background-size: 22px;
    cursor: pointer;
  }

  button[type="submit"]:hover {
    opacity: 0.8;
  }

  button[type="submit"]:focus,
  input[type="search"]:focus {
    box-shadow: 0 0 3px 0 #1183d6;
    border-color: #1183d6;
    outline: none;
  }
}
</style>
